export const sinIva = (idLinea: number) => (idLinea == 4 || idLinea == 6 || idLinea == 8);
